export enum LayerType {
  CUT = "CUT",
  FOLD = "FOLD",
  MARK = "MARK",
}
